import { call, put, takeEvery } from "redux-saga/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import authService, {
  LoginCredentials,
  RegisterData,
} from "../../services/authService";
import {
  loginStart,
  loginSuccess,
  loginFailure,
  registerStart,
  registerSuccess,
  registerFailure,
  getProfileStart,
  getProfileSuccess,
  getProfileFailure,
  updateProfileStart,
  updateProfileSuccess,
  updateProfileFailure,
} from "../slices/authSlice";

// Login saga
function* loginSaga(
  action: PayloadAction<LoginCredentials>
): Generator<any, void, any> {
  try {
    const response: any = yield call(authService.login, action.payload);
    yield put(
      loginSuccess({
        user: response.user,
        token: response.token,
        customer: response.customer,
        pharmacyName: response.pharmacyName,
      })
    );
  } catch (error: any) {
    yield put(loginFailure(error.response?.data?.message || "Login failed"));
  }
}

// Register saga
function* registerSaga(
  action: PayloadAction<RegisterData>
): Generator<any, void, any> {
  try {
    const response: any = yield call(authService.register, action.payload);
    yield put(registerSuccess({ user: response.user, token: response.token }));
  } catch (error: any) {
    yield put(
      registerFailure(error.response?.data?.message || "Registration failed")
    );
  }
}

// Get profile saga
function* getProfileSaga(): Generator<any, void, any> {
  try {
    const response: any = yield call(authService.getProfile);
    yield put(
      getProfileSuccess({
        user: response.user,
        customer: response.customer,
        pharmacyName: response.pharmacyName,
      })
    );
  } catch (error: any) {
    yield put(
      getProfileFailure(
        error.response?.data?.message || "Failed to get profile"
      )
    );
  }
}

// Update profile saga
function* updateProfileSaga(
  action: PayloadAction<{ name: string; email: string }>
): Generator<any, void, any> {
  try {
    const response: any = yield call(authService.updateProfile, action.payload);
    yield put(updateProfileSuccess(response.user));
  } catch (error: any) {
    yield put(
      updateProfileFailure(
        error.response?.data?.message || "Failed to update profile"
      )
    );
  }
}

// Watchers
export function* watchLoginSaga() {
  yield takeEvery(loginStart.type, loginSaga);
}

export function* watchRegisterSaga() {
  yield takeEvery(registerStart.type, registerSaga);
}

export function* watchGetProfileSaga() {
  yield takeEvery(getProfileStart.type, getProfileSaga);
}

export function* watchUpdateProfileSaga() {
  yield takeEvery(updateProfileStart.type, updateProfileSaga);
}
